<div class="tabella">
  <!-- Il contenitore che scorre: una tabella larga scorre qui dentro, non trascina la pagina. -->
  <div class="tabella__scorrimento">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortChange.emit($event)" class="tabella__griglia">
      @for (colonna of columnDefinitions; track colonna.id) {
        <ng-container [matColumnDef]="$any(colonna.id)">
          @if (colonna.sortable) {
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              [style.width]="colonna.width"
              [class]="classeAllineamento(colonna)"
              [class.tabella__cella--solo-larghi]="colonna.nascondiSuMobile"
            >
              {{ intestazione(colonna) }}
            </th>
          } @else {
            <th
              mat-header-cell
              *matHeaderCellDef
              [style.width]="colonna.width"
              [class]="classeAllineamento(colonna)"
              [class.tabella__cella--solo-larghi]="colonna.nascondiSuMobile"
            >
              {{ intestazione(colonna) }}
            </th>
          }

          <td
            mat-cell
            *matCellDef="let riga"
            [attr.data-etichetta]="etichettaCella(colonna)"
            [class]="classeAllineamento(colonna)"
            [class.tabella__cella--solo-larghi]="colonna.nascondiSuMobile"
          >
            @if (colonna.template) {
              <ng-container [ngTemplateOutlet]="colonna.template" [ngTemplateOutletContext]="{ $implicit: riga }" />
            } @else {
              {{ valore(riga, colonna) }}
            }
          </td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let riga; columns: displayedColumns"
        class="tabella__riga"
        [class.tabella__riga--cliccabile]="rigaCliccabile"
        [attr.tabindex]="rigaCliccabile ? 0 : null"
        (click)="scegliRiga(riga)"
        (keydown.enter)="scegliRiga(riga)"
      ></tr>
    </table>

    @if (caricamento) {
      <div class="tabella__scheletro" aria-hidden="true">
        @for (riga of scheletro; track riga) {
          <div class="tabella__scheletro-riga"></div>
        }
      </div>
    }
  </div>

  @if (errore) {
    <div class="tabella__errore" role="alert">
      <mat-icon aria-hidden="true">error_outline</mat-icon>
      <div>
        <p class="tabella__errore-titolo">Non e' stato possibile caricare l'elenco</p>
        <p class="tabella__errore-motivo">{{ errore }}</p>
      </div>
    </div>
  } @else if (vuota) {
    <div class="tabella__vuoto">
      <mat-icon aria-hidden="true">inbox</mat-icon>
      <p>{{ etichettaVuoto ?? noElementsMessage }}</p>
    </div>
  }

  <mat-paginator
    class="tabella__paginatore"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="showFirstLastButtons"
    (page)="cambiaPagina($event)"
  />
</div>
